export default "/assets/images/mila-room-showcase-01.jpg?8f44e311e5ed3714486b4ff4119167c6";